import { BoxProps } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

export const useImageBackground = (image: string | undefined): BoxProps => {
  const [bgImageStyle, setBgImageStyle] = useState<BoxProps>({})

  useEffect(() => {
    const loadImage = () => {
      if (image) {
        const newImg = new window.Image()
        // eslint-disable-next-line functional/immutable-data
        newImg.src = image
        // eslint-disable-next-line functional/immutable-data
        newImg.onload = () => {
          setBgImageStyle({
            backgroundImage: `url(${image})`,
            backgroundPosition: '50% 50%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          })
        }
        // eslint-disable-next-line functional/immutable-data
        newImg.onerror = () => {
          setBgImageStyle({
            backgroundColor: 'gray.200',
            backgroundPosition: '50% 50%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          })
        }
      }
    }
    loadImage()
  }, [image])

  return bgImageStyle
}
